import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ReactFlowProvider } from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import '../../css/flow-builder.css';
import { FlowBuilderApp } from './FlowBuilderApp';
import { ThemeProvider } from './ThemeContext';
import { useAppSelector } from '../../hooks/hooks';
import { ROUTES } from '../../routes/routesPaths';

export const FlowBuilderPage = () => {
  const { flowId } = useParams();
  const companyId = useAppSelector((state) => state.session?.company_id) || 'default';

  return (
    <div
      className="flow-builder-root-container"
      style={{
        height: 'calc(100vh - 110px)',
        width: '100%',
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <ThemeProvider>
        <ReactFlowProvider>
          <FlowBuilderApp
            flowId={flowId}
            tenantId={companyId}
            backUrl={ROUTES.FLOWS_LIST || '/flows'}
            csrfToken=""
          />
        </ReactFlowProvider>
      </ThemeProvider>
    </div>
  );
};

export default FlowBuilderPage;
